import { Pipe, PipeTransform } from '@angular/core';
import { GuestTitle } from '../constants/commonenums';
import moment from 'moment';

@Pipe({
    name: 'dateCompareByDay',
    standalone: false
})
export class DateComparePipe implements PipeTransform {

  transform(date1, date2): boolean {
    if(!date1 || !date2){
        return true;
    }
    let numOfDays = moment(date1).diff(date2, 'days');
    return  numOfDays > 0;
  }

}
